import React, { useMemo } from "react"
import { graphql, useStaticQuery } from "gatsby"

import IconTitleGridContactPromo from "../../design-system/templates/icon-title-grid-contact-promo"

const TrendsInsightsDataProvider = () => {
  const {
    sessionNumberIcon,
    lengthSessionIcon,
    deviceUsedIcon,
    categoryIcon,
    quickLinkSelectionIcon,
    eventSelectionIcon,
    locationSelectedIcon,
    charactersTypedIcon,
  } = useStaticQuery(graphql`
    query {
      sessionNumberIcon: file(
        relativePath: {
          eq: "1_SOLUTIONS/Mapping CMS - Internal Pages/Analytics Dashboard/Icons/sessions.svg"
        }
      ) {
        publicURL
      }
      lengthSessionIcon: file(
        relativePath: {
          eq: "1_SOLUTIONS/Mapping CMS - Internal Pages/Analytics Dashboard/Icons/length.svg"
        }
      ) {
        publicURL
      }
      deviceUsedIcon: file(
        relativePath: {
          eq: "1_SOLUTIONS/Mapping CMS - Internal Pages/Analytics Dashboard/Icons/device.svg"
        }
      ) {
        publicURL
      }
      categoryIcon: file(
        relativePath: {
          eq: "1_SOLUTIONS/Mapping CMS - Internal Pages/Analytics Dashboard/Icons/category.svg"
        }
      ) {
        publicURL
      }
      quickLinkSelectionIcon: file(
        relativePath: {
          eq: "1_SOLUTIONS/Mapping CMS - Internal Pages/Analytics Dashboard/Icons/links.svg"
        }
      ) {
        publicURL
      }
      eventSelectionIcon: file(
        relativePath: {
          eq: "1_SOLUTIONS/Mapping CMS - Internal Pages/Analytics Dashboard/Icons/event.svg"
        }
      ) {
        publicURL
      }
      locationSelectedIcon: file(
        relativePath: {
          eq: "1_SOLUTIONS/Mapping CMS - Internal Pages/Analytics Dashboard/Icons/locations.svg"
        }
      ) {
        publicURL
      }
      charactersTypedIcon: file(
        relativePath: {
          eq: "1_SOLUTIONS/Mapping CMS - Internal Pages/Analytics Dashboard/Icons/characters.svg"
        }
      ) {
        publicURL
      }
    }
  `)

  const gridItems = useMemo(
    () => [
      {
        icon: <img src={sessionNumberIcon.publicURL} alt="Device icon" />,
        title: "Number of Sessions",
      },
      {
        icon: (
          <img src={lengthSessionIcon.publicURL} alt="Length of session icon" />
        ),
        title: "Length of Sessions",
      },
      {
        icon: <img src={deviceUsedIcon.publicURL} alt="Device icon" />,
        title: "Device Used",
      },

      {
        icon: (
          <img src={eventSelectionIcon.publicURL} alt="Event selections icon" />
        ),
        title: "Event Selections",
      },
      {
        icon: (
          <img src={quickLinkSelectionIcon.publicURL} alt="Quick links icon" />
        ),
        title: "Quick Link Selections",
      },
      {
        icon: <img src={categoryIcon.publicURL} alt="Category sessions icon" />,
        title: "Category Selections",
      },
      {
        icon: (
          <img
            src={locationSelectedIcon.publicURL}
            alt="Location selected icon"
          />
        ),
        title: "Locations Selected From Search",
      },
      {
        icon: (
          <img
            src={charactersTypedIcon.publicURL}
            alt="Characters typed icon"
          />
        ),
        title: "Characters Typed During Search",
      },
    ],
    [
      sessionNumberIcon,
      lengthSessionIcon,
      deviceUsedIcon,
      categoryIcon,
      quickLinkSelectionIcon,
      eventSelectionIcon,
      locationSelectedIcon,
      charactersTypedIcon,
    ]
  )

  return (
    <IconTitleGridContactPromo
      title="Trends & Insights"
      description="Mappedin is dedicated to client success. Our platform offers an accessible suite of map management tools that add value to your business and its map users."
      gridItems={gridItems}
    />
  )
}

export default TrendsInsightsDataProvider
